import { TypePolicy } from '@apollo/client'

export const subscriptionInfoTypePolicy = {
    SubscriptionInfo: {
        keyFields: ['salesforceId'],
    } as TypePolicy,
}
